import styled from 'styled-components'

export const CarouselContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  flex: 0;
`;

export const BodyHorizontalScroller = styled.div`
  overflow-x: auto;

  scroll-behavior: smooth;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }
`;

export const BodyHorizontalScroll = styled.div`
  flex: 1;
  max-width: 100%;
  display: flex;
  -webkit-overflow-scrolling: touch;
  overflow-x: scroll;
  scroll-behavior: smooth;
  touch-action: pan-y;
  overflow-x: ${p => p.$grid ? 'visible' : 'scroll'};

  &::-webkit-scrollbar {
    display: none;
  }
`;


export const Content = styled.div.attrs({
})`
  scroll-snap-align: start;
`;

export const BodyHorizontalScrollBody = styled.div.attrs({
})`
  min-width: ${p => p.viewAll || p.$grid ? '0' : 'fit-content'};
  width: ${p => p.viewAll || p.$grid ? '100%' : 'auto'};
  display: ${p => p.$grid ? 'grid' : 'flex'};
  grid-template-columns: ${p => p.$grid ? 'repeat(auto-fill, minmax(min(100%, 280px), 1fr))' : 'none'};
  align-items: flex-start;
  gap:${p => p.nospace ? "0px" : typeof p.gap === "number" ? `${p.gap}px` : (p.gap || "24px")};
  user-select: none;
  ${p => p.viewAll && !p.$grid ? `
      flex-wrap: wrap;
      cursor: default;
      `: ``}

  @media (max-width: 991px) {
  }

  @media (max-width: 400px) {
    width: 100%;
  }
`;

export const DivBigSize = styled.div.attrs({
})`
  min-width: 24000px;
  height: 400px;
  background: pink;
`;
